// extracted by mini-css-extract-plugin
export default {"container":"container___eomBe","section":"section___N0ITQ","glitch":"glitch____buJF","noise-anim":"noise-anim___ve7Ys","noise-anim-2":"noise-anim-2___QXO9Z"};